import React from 'react';
import Icon from './Icon';

export const alignClass = (align) => (align === 'right' ? ' list-table-right' : align === 'center' ? ' list-table-center' : '');

function HeadCell({ column, sort, onSort, tableRoles }) {
  const sorted = sort?.key === column.key;
  const sortWord = sorted ? (sort.dir === 'asc' ? 'ascending' : 'descending') : undefined;
  const role = tableRoles ? 'columnheader' : undefined;
  if (!column.sort || !onSort) {
    return <div role={role} className={alignClass(column.align).trim() || undefined}>{column.title}</div>;
  }
  const arrow = (
    <Icon
      name={sorted ? (sort.dir === 'asc' ? 'arrow-up' : 'arrow-down') : 'arrows-down-up'}
      size={12}
      className="list-table-sort-icon"
    />
  );
  const label = <span className="list-table-sort-label">{column.title}</span>;
  return (
    <div role={role} aria-sort={tableRoles ? sortWord : undefined} className={alignClass(column.align).trim() || undefined}>
      <button
        type="button"
        className={`list-table-sort${sorted ? ' is-sorted' : ''}`}
        onClick={() => onSort(column)}
      >
        {column.align === 'right' ? <>{arrow}{label}</> : <>{label}{arrow}</>}
        {/* Without table roles there's no aria-sort, so the button says it. */}
        {!tableRoles && sorted && <span className="list-table-sr">, sorted {sortWord}</span>}
      </button>
    </div>
  );
}

/**
 * The List table's head (PRD-1700): one cell per column. A column with a
 * `sort` type is a button with a 12 arrow that shows on hover and focus and
 * stays, in icon-black, on the sorted column; on a right-aligned column the
 * arrow leads, so the title lines up with the figures.
 */
function ListTableHead({ headRef, columns, sort, onSort, tableRoles }) {
  return (
    <div ref={headRef} className="list-table-headwrap" role={tableRoles ? 'rowgroup' : undefined}>
      <div className="list-table-head" role={tableRoles ? 'row' : undefined}>
        {columns.map((column) => (
          <HeadCell key={column.key} column={column} sort={sort} onSort={onSort} tableRoles={tableRoles} />
        ))}
      </div>
    </div>
  );
}

export default ListTableHead;
